module.exports = "# 应用类型\n\n## 商家自有接入\n商家自用型应用，主要为有开发能力的供应商进行系统对接，通过平台颁发的client_id和secert就能直接调用对应的商品、订单等数据接口。\n## 服务商应用接入\n服务商可通过创建服务型应用，来为有量的商家提供增值服务。服务型应用需要用户登录授权后，才能调用对应商家的数据接口。\n如果您有任何建议可直接联系我们"


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/guide/apptype.md
 ** module id = 589
 ** module chunks = 1
 **/